import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute} from "@angular/router";
import { ContentAuthoringService } from "../../services/content-authoring.service";
import { NgxSpinnerService } from "ngx-spinner";
import {debounceTime, map} from "rxjs/operators"
import { fromEvent } from 'rxjs';


// export interface UserData {
//   id: string;
//   name: string;
//   progress: string;
//   color: string;
// }

@Component({
  selector: 'app-user-list',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})

export class UserComponent implements OnInit {
  submitted = false; userId: any = ''; type: any = ''; organisationData: any;
  searchText = ""; user_status = "2"; is_active = "1"; order_by = "created_dttm"; order = "DESC";
  errorInfo: { isError: boolean, errorMsg: string } = { isError: false, errorMsg: '' }
  data = {}; userData: any; capsule_name: any; media_type = ''; adminData: any; filter_by: any = "";
  tabName: any = ''; user_id: any = ''; user_type: number = 1
  userDataList: any;
  @ViewChild('searchUser', {static:true})searchUser:ElementRef | undefined
  totalUserDetail: any;

  constructor(private modalService: NgbModal, private contentAuthoringApi: ContentAuthoringService,
    private route: ActivatedRoute,
    private router: Router, private spinner: NgxSpinnerService) {
    if (localStorage.getItem('adminData') == '' || localStorage.getItem('adminData') == null) {
      this.router.navigateByUrl('/admin-login');
    }
  }

  open(content: any, user_id: any, tab_name: any) {
    this.tabName = tab_name;
    this.user_id = user_id;
    this.modalService.open(content, { centered: true, size: 'sm' });
  }
  ngOnInit(): void {
    console.log("oninit")
    this.is_active = '1';
    this.user_status = '2';
    this.getUserList(this.searchText, this.is_active, this.order_by, this.order, this.filter_by, this.user_type); //draft
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    this.route.queryParams.subscribe(queryParams => {
      this.userId = queryParams['id'];
      this.type = queryParams['type'];
    });
    this.getOrganisationList(this.searchText, this.is_active, this.order_by, this.order);
    if (this.userId != '' && this.userId != null) {
      this.getUserDetails(this.userId);
    }
    fromEvent(this.searchUser?.nativeElement, 'keyup').pipe(
      map((e:any)=> e?.target.value),debounceTime(1000)
    ).subscribe((res:any)=>{
      this.searchText=res
      this.getUserList(this.searchText, this.is_active, this.order_by, this.order, this.filter_by, this.user_type);
    })
  }
  selectChangeHandler(event: any) {
    this.filter_by = event.target.value;
    if (this.filter_by == 0) {
      this.filter_by = "";
      this.getUserList(this.searchText, this.is_active, this.order_by, this.order, this.filter_by, this.user_type);
    } else {
      console.log(this.filter_by);
      this.getUserList(this.searchText, this.is_active, this.order_by, this.order, this.filter_by, this.user_type);
    }
  }
  /****serach by course name */
  getUser(event: any) {
    this.searchText = event.target.value;
    this.getUserList(this.searchText, this.is_active, this.order_by, this.order, this.filter_by, this.user_type);
  }

  getOrganisationList(searchText: any, is_active: any, order_by: any, order: any) {
    this.contentAuthoringApi.getOrganisationList("", is_active, order_by, this.order).subscribe(
      (data) => {
        console.log(data);
        if (data.success) {
          this.organisationData = data.organisationList;
        } else {
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist';
        }
      },
      (error) => {
        this.errorInfo.errorMsg = error;
      },
    );
  }

  getUserDetails(courseId: any) {
  }

  /*******get active and deactive data of users */
  onSelectChange(event: any) {
    if (event.index == 1) { //deactive
      this.is_active = '0';
    } else {
      this.is_active = '1'; //active
    }
    this.getUserList(this.searchText, this.is_active, this.order_by, this.order, this.filter_by, this.user_type);
  }

  /*get user listing data********/
  getUserList(searchText: any, is_active: any, order_by: any, order: any, filter_by: any, user_type: any) {
   this.spinner.show();
   let data={
    searchText:searchText,
    is_active: is_active,
    order_by: order_by,
    order: order,
    filter_by: filter_by,
    user_type: user_type
   }
    this.contentAuthoringApi.getUserList(searchText, is_active, order_by, order, filter_by, user_type).subscribe(
      (data:any) => {
        if (data.success) {
         this.spinner.hide();
         this.totalUserDetail=data;
          this.userDataList = data.userList;
        } else {
          this.spinner.hide();
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }

  /*****get data by searching by name */
  search(event: any) {
    this.searchText = event.target.value;
    this.getUserList(this.searchText, this.is_active, this.order_by, this.order, this.filter_by, this.user_type);
  }

  sortData(sort: any) {
    if (sort.direction == 'desc') {
      this.order_by = sort.active; this.order = 'DESC';
    } else if (sort.direction == 'asc') {
      this.order_by = sort.active; this.order = 'ASC';
    } else { this.order_by = 'end_date'; this.order = 'DESC'; }
    // this.courseList(this.course_name, this.is_active, this.course_status, this.order_by, this.order);
    this.getUserList(this.searchText, this.is_active, this.order_by, this.order, this.filter_by, this.user_type);
  }
  /*****click on logout button function ******/
  logout() {
    //localStorage.clear();
    localStorage.removeItem('adminLoginPass');
    localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
  }
  /*******status change in active or deactive  *****/
  changeIsDeActiveVal(user_id: any, is_actives: any) {
    this.changeIsActiveVal(user_id, is_actives);
  }
  changeIsActiveVal(user_id: any, is_active: any) {
    this.contentAuthoringApi.changeUserIsActiveVal(user_id, is_active).subscribe(
      (data) => {
        if (data.status == 200) {
          document.getElementById('closelId')?.click();
          this.getUserList(this.searchText, this.is_active, this.order_by, this.order, this.filter_by, this.user_type);
          // this.router.navigate(['/courses']);
        } else {
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        this.errorInfo.errorMsg = error;
      },
    );
  }
  deleteUser(user_id: any) {
    this.contentAuthoringApi.deleteUsers(user_id).subscribe(
      (data) => {
        if (data.Status == 200) {
          document.getElementById('closelId')?.click();
          this.getUserList(this.searchText, this.is_active, this.order_by, this.order, this.filter_by, this.user_type);
          // this.router.navigate(['/courses']);
        } else {
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        this.errorInfo.errorMsg = error;
      },
    );

  }
}





